import Select, { Props } from 'react-select';
import React from 'react';
import classNames from 'classnames';

interface IProps {
  whiteBackground?: boolean;
  fullWidth?: boolean;
}

export interface ISelectOption {
  value: string;
  label: string;
}

const CustomSelect = ({ whiteBackground = false, fullWidth = false, ...rest }: IProps & Props) => {
  const wrapperClassName = classNames({
    'w-100': fullWidth,
  });

  return (
    <div
      data-testid={rest['data-testid' as keyof Props]}
      className={wrapperClassName}
      style={fullWidth ? { flex: 1, minWidth: 0 } : undefined}
    >
      <Select
        className={classNames('react-select__container', {
          'react-select__container--white-bg': whiteBackground,
          'react-select__container--full-width': fullWidth,
        })}
        classNamePrefix="react-select"
        {...rest}
      />
    </div>
  );
};

CustomSelect.defaultProps = {
  whiteBackground: false,
};

export default CustomSelect;
